import config from './config.js'

export default {
  viewparams: {"start":0,"count":20,"sort":"send","dir":"desc","open":"","type":""},
  tempparams: {"start":0,"count":20,"sort":"map_id","dir":"desc","open":"","type":""},

  listrequests: function(ctrl,cb_success) {
    var u = config.baseUrl + 'rest/service/requests?start=' + this.viewparams.start + '&count=' + this.viewparams.count;
    u += '&sort=' + this.viewparams.sort + '&dir=' + this.viewparams.dir + '&open=' + this.viewparams.open + '&type=' + this.viewparams.type;
    config.get(ctrl,u,'Service Request Liste laden',cb_success);
  },

  loadrequest: function(ctrl,id,cb_success) {
    var u = config.baseUrl + 'rest/service/requests/' + encodeURIComponent(id);
    config.get(ctrl,u,'Service Request laden',cb_success);
  },

  reworkrequest: function(ctrl,id,cb_success) {
    var u = config.baseUrl + 'rest/service/rework/' + encodeURIComponent(id);
    config.get(ctrl,u,'Service Request ausführen',cb_success);
  },

  listtempnames: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/service/names','Vorlagenamen laden',cb_success);
  },

  listtemplates: function(ctrl,cb_success) {
    var u = config.baseUrl + 'rest/service/templates?start=' + this.tempparams.start + '&count=' + this.tempparams.count;
    u += '&sort=' + this.tempparams.sort + '&dir=' + this.tempparams.dir + '&open=' + this.tempparams.open + '&type=' + this.tempparams.type;
    config.get(ctrl,u,'Vorlagen laden',cb_success);
  },

  loadtemplate: function(ctrl,id,cb_success) {
    var u = config.baseUrl + 'rest/service/templates/' + encodeURIComponent(id);
    config.get(ctrl,u,'Vorlage laden',cb_success);
  },

  savetemplate: function(ctrl,template,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/service/templates','Vorlage sichern',JSON.stringify(template),cb_success);
  },

  deletetemplate: function(ctrl,mid,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/service/templates/' + encodeURIComponent(mid),'Service Vorlage löschen',cb_success);
  },

  tasklist: function(ctrl,role,cb_success) {
    var url = config.baseUrl + 'rest/wf/tasks' + (role ? ('?role=' + encodeURIComponent(role)) : '');
    config.get(ctrl,url,'Aufgaben laden',cb_success);
  },

  startlist: function(ctrl,userid,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/startlist' + (userid ? ('?userid=' + encodeURIComponent(userid)) : ''),'Prozess Starts laden',cb_success);
  },

  starttaskproc: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/start?procid=' + encodeURIComponent(id),'Prozess starten',cb_success);
  },

  loadtaskform: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/tasks/' + encodeURIComponent(id) + '/form','Aufgabe laden',cb_success);
  },

  submittaskform: function(ctrl,id,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/wf/tasks/' + encodeURIComponent(id) + '/form','Aufgabe abschließen',JSON.stringify(data),cb_success);
  }

}
